import { CSSProperties, useEffect, useState } from "react";
import { DiscountWidgetProps } from "../models/PropsInterface";
import ColorsUtils from "../utils/ColorsUtils";
import "../cssStyles/DiscountWidget.css";

const DiscountWidget = (props: DiscountWidgetProps) => {
  const [countdown, setCountdown] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetTime =
      new Date().getTime() + props.discount_widget.count_down_duration * 1000;
    const countdownInterval = setInterval(() => {
      const now = new Date().getTime();
      const remainingTime = targetTime - now;

      if (remainingTime <= 0) {
        clearInterval(countdownInterval);
      } else {
        const hours = Math.floor(remainingTime / (1000 * 60 * 60));
        const minutes = Math.floor(
          (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

        setCountdown({ hours, minutes, seconds });
      }
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [props.discount_widget.count_down_duration]);

  // Helper function to pad zeros to single-digit numbers
  const padZero = (num: number): string => {
    return num < 10 ? "0" + num : num.toString();
  };

  const discountWidgetBackgroundColor = ColorsUtils.convertHexToRgb(
    props.discount_widget && props.discount_widget.background_color
  );

  const backgroundTextStyle = {
    backgroundColor: `${
      discountWidgetBackgroundColor
        ? `rgb(${discountWidgetBackgroundColor.r},${discountWidgetBackgroundColor.g},${discountWidgetBackgroundColor.b}, ${discountWidgetBackgroundColor.a})`
        : ""
    }`,
    color: props.discount_widget.text_color,
  } as CSSProperties;

  let countDown =
    props.language == "en"
      ? `${padZero(countdown.hours)} : ${padZero(
          countdown.minutes
        )} : ${padZero(countdown.seconds)}`
      : `${padZero(countdown.seconds)} : ${padZero(
          countdown.minutes
        )} : ${padZero(countdown.hours)}`;

  return (
    <>
      <div
        id={"demo"}
        style={backgroundTextStyle}
        className={"discount_widget-container"}
      >
        {`${props.discount_widget.text} ${countDown} `}
      </div>
    </>
  );
};

export default DiscountWidget;
